<template>
  <div class="node-menu">
    <div v-if="sideBarPage === 'new-step'" style="display:flex;flex-direction:column; gap:0.3rem">
      <span class="w-full text-center">בחירת תנאי</span>
      <span class="intro mt-2">
        <i style="font-size: 0.8rem" class="pi pi-info-circle"/>
        בשלב זה נבחר את התנאי שיפעיל את האוטומציה. לדוגמא: נניח שבחרנו "לקוח הזמין תור", כעת נוכל להתנות מה קורה לאחר התור, ואז מה נרצה לעשות אם התנאי מתממש.
      </span>

      <div>
        <div
          v-for="(action, idx) of automationActionsTree[automation.steps[0].action][automation.steps?.length === 1 ? 'triggers' : 'actions']"
          v-if="automation?.steps"
          :key="action">
          <div
            style="display:flex; flex-direction: column; margin-top: 1rem;;"
            @click="addStep(action)">
            <span><i class="pi pi-angle-left"/> {{ triggersMapping[action].name }}</span>
            <span style="margin-right: 1.1rem; font-size: 1rem; font-weight:400;">{{ triggersMapping[action].desc }}</span>
          </div>
          <divider/>
        </div>
      </div>
    </div>

    <div v-if="sideBarPage === 'init'" class="node-menu">
      <label class="subtitle label" for="title">שם מזהה</label>
      <input-text
        id="title"
        v-model="automation.name"
        placeholder="שם שיעזור לך לזהות את האוטומציה הזו"
        type="text"/>

      <div v-for="action in automationsStarts" :key="action">
        <div
          style="display:flex; flex-direction: column; margin-top: 1rem;"
          @click="addStep(action)">
          <span><i class="pi pi-angle-left"/> {{ triggersMapping[action].name }}</span>
          <span style="margin-right: 1.1rem; font-size: 1rem; font-weight:400;">{{ triggersMapping[action].desc }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ISmsAutomation, SmsAutomationActions } from '@torim-app/types';
import { automationActionsTree, automationsStarts, triggersMapping } from '@app/components/admin/pages/communication/automations-consts';
import { useDrawer } from '@torim-app/shared-components';
import { onUnmounted, type PropType } from 'vue';

const { closeDrawer } = useDrawer();

const props = defineProps({
  sideBarPage: {
    type: String as PropType<'new-step' | 'init'>,
    required: true
  },
  automation: {
    type: Object as PropType<ISmsAutomation>,
    required: true
  },
  automationId: {
    type: String,
    required: true
  },
  onAddStep: {
    type: Function as PropType<(action: SmsAutomationActions) => void>,
    required: true
  },
  onSidebarHidden: {
    type: Function as PropType<() => void>,
    required: false,
    default: undefined
  }
});

const addStep = (action: SmsAutomationActions) => {
  props.onAddStep(action);
  closeDrawer();
};

onUnmounted(() => {
  props.onSidebarHidden?.();
});
</script>

<style lang="scss">
@use '../../../assets/css/vars' as *;

.node-menu {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  font-weight: 500;
  font-size: 1.05rem;
  gap: 1rem;

  .intro {
    font-size: 0.85rem;
    padding: 0.75rem;
    background-color: $gray-bg;
    border-radius: 0.4rem;
    margin-bottom: 0.5rem;
    font-weight: 400;
  }
}
</style>
